import { createSlice } from "@reduxjs/toolkit";
import { getWebOrder, getSingleOrder } from "../../reduxApi/website/OrdersReduxApi";

const WebOrdersSlice = createSlice({
  name: "order",
  initialState: {
    status: "idle",
    orders: [],
    singleOrder: null,  // Add this for single order
    loading: false,
    error: null
  },
  reducers: {
    clearOrders: (state) => {
      state.orders = [];
      state.singleOrder = null;
      state.error = null;
    }
  },
  extraReducers: (builder) => {
    builder
      // Get all orders
      .addCase(getWebOrder.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getWebOrder.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.loading = false;
        if (action.payload?.orders && Array.isArray(action.payload.orders)) {
          state.orders = action.payload.orders.map(item => item.salesOrder);
          console.log("Orders stored in Redux:", state.orders);
        } else {
          state.orders = [];
        }
      })
      .addCase(getWebOrder.rejected, (state, action) => {
        state.status = "rejected";
        state.loading = false;
        state.error = action.payload || "Failed to fetch orders";
        state.orders = [];
      })
      
      // Get single order
      .addCase(getSingleOrder.pending, (state) => {
        state.status = "loading";
        state.loading = true;
        state.error = null;
      })
      .addCase(getSingleOrder.fulfilled, (state, action) => {
        state.status = "fulfilled";
        state.loading = false;
        state.singleOrder = action.payload;  // Store the single order response
        console.log("Single order stored in Redux:", action.payload);
      })
      .addCase(getSingleOrder.rejected, (state, action) => {
        state.status = "rejected";
        state.loading = false;
        state.error = action.payload || "Failed to fetch single order";
        state.singleOrder = null;
      });
  },
});

export const { clearOrders } = WebOrdersSlice.actions;
export default WebOrdersSlice.reducer;